import axios from "axios";
import Swal from "sweetalert2";

export default {
    state:{
        itemsclientes:[],
        itemselected:false,
    },
    mutations:{
        setClientes(state,clientes){
            state.itemsclientes=clientes
        },
        setItemSelected(state,cliente){
            state.itemselected=cliente
        }
    },
    actions:{
       async setClientes({commit,rootState,getters}){
           await axios.get(`${rootState.urlapi}/personas/`,getters.getTokenUser).then(response=>{
                commit("setClientes",response.data)
              }).catch(err=>{console.error(err)});
        },
       async createCliente({rootState,getters},item){
           try {
                const {data} = await axios.post(`${rootState.urlapi}/personas`,item,getters.getTokenUser)
                Swal.fire("Registro Creado","","success");
                return data
           } catch (error) {
               console.log(error)
               Swal.fire("Ocurrio un error al crear el registro","","error");
           }
           
        },
        setItemSelected({commit},cliente){
            commit("setItemSelected",cliente)
        }
    },
    getters:{
        getAllClientes(state){
            return state.itemsclientes
        },
        getClientes: (state) => (nit) => {
            return state.itemsclientes.find(elemento=>elemento.nit==nit)
        },
        getClientePorCodigo:(state)=> (codigo) =>{
            return state.itemsclientes.find(elemento=>elemento.codigo==codigo)
        }
    }
}